import { ChannelModel } from "../../channel/models/ChannelModel";

export class ProductBatchPriceValueManagementByChannelModel {
    idStore: number|null = null;
    channels: string[] = [];
    channelsWrapper?: Array<Partial<ChannelModel>> = [];

    constructor(s?: Partial<ProductBatchPriceValueManagementByChannelModel>) {
        Object.assign(this, s)
    }

    isValid():boolean {
        return !!this.idStore && 
            !!this.channelsWrapper?.length
    }

    hasChannels():boolean {
        return !!this.channelsWrapper?.length;
    }

    clearChannels():void {
        this.channels = [];
        this.channelsWrapper = [];
    }

    normalize(): ProductBatchPriceValueManagementByChannelModel {
        return new ProductBatchPriceValueManagementByChannelModel({
            idStore: this.idStore,
            channels: (this.channelsWrapper || []).map((c) => c.id) as string [],
            channelsWrapper: this.channelsWrapper,
        })
    }
}

